<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Conversion</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (conversion) {
    <div>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between">
        <h3 class="fw-bold fs-6 mb-0">General</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ conversion.id }}</td>
          </tr>
          <tr>
            <th>
              Created at
            </th>
            <td>
              {{ conversion.createdAt | parisDate }}
            </td>
          </tr>
          <tr>
            <th>
              Conversion at
            </th>
            <td>
              {{ conversion.conversionDate | parisDate }}
            </td>
          </tr>
          <tr>
            <th>
              CID
            </th>
            <td>
              {{ conversion.cid }}
            </td>
          </tr>
          <tr>
            <th>
              Goal
            </th>
            <td>
              {{ conversion.goalName }}
            </td>
          </tr>
          <tr>
            <th>
              Goal Type
            </th>
            <td>
              {{ conversion.goalTypeName }}
            </td>
          </tr>
          <tr>
            <th>
              Brand
            </th>
            <td>
              {{ conversion.product }}
            </td>
          </tr>
          <tr>
            <th>
              Order Reference
            </th>
            <td>
              {{ conversion.orderReference }}
            </td>
          </tr>
          <tr>
            <th>
              Unique Conversion Reference
            </th>
            <td>
              {{ conversion.uniqueReference }}
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              @if (conversion.accepted) {
                <span class="badge rounded-pill text-bg-success">Accepted</span>
              }
              @if (!conversion.accepted) {
                <span class="badge rounded-pill text-bg-danger">Rejected</span>
              }
            </td>
          </tr>
          <tr>
            <th>Private</th>
            <td>
              @if (conversion.private) {
                <span class="badge rounded-pill text-bg-success">Yes</span>
              }
              @if (!conversion.private) {
                <span class="badge rounded-pill text-bg-danger">No</span>
              }
            </td>
          </tr>
          <tr>
            <th>Paid</th>
            <td>
              @if (conversion.paid) {
                <span class="badge rounded-pill text-bg-success">Yes</span>
              }
              @if (!conversion.paid) {
                <span class="badge rounded-pill text-bg-danger">No</span>
              }
            </td>
          </tr>
          <tr>
            <th>Multiple</th>
            <td>
              @if (conversion.multiple) {
                <span class="badge rounded-pill text-bg-success">Yes</span>
              }
              @if (!conversion.multiple) {
                <span class="badge rounded-pill text-bg-danger">No</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Payment</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>
              Amount
            </th>
            <td>
              {{ (conversion.currencyAmount ? conversion.currencyAmount / 100 : '') | currency:2:$safeNavigationMigration(conversion.currency?.isoCode) }}
              @if (conversion.currencyAmount) {
                <span>({{ (conversion.amount ? conversion.amount / 100 : '') | currency:2 }}
                )</span>
              }
            </td>
          </tr>
          <tr>
            <th>
              Method
            </th>
            <td>
              {{ conversion.paymentMethod }}
            </td>
          </tr>
          <tr>
            <th>
              PSP
            </th>
            <td>
              {{ conversion.paymentPsp }}
            </td>
          </tr>
          <tr>
            <th>
              Acquirer
            </th>
            <td>
              {{ conversion.paymentAcquirer }}
            </td>
          </tr>
          <tr>
            <th>
              3DS
            </th>
            <td>
              {{ conversion.paymentThreeDSecure }}
            </td>
          </tr>
          <tr>
            <th>
              Partial
            </th>
            <td>
              {{ conversion.paymentPartial }}@if (conversion.paymentPartial) {
              <span
              > - {{ conversion.paymentPartialNumber }}</span>
            }
          </td>
        </tr>
        <tr>
          <th>
            Retry
          </th>
          <td>
            {{ conversion.paymentRetry }}
          </td>
        </tr>
        <tr>
          <th>
            Reference
          </th>
          <td>
            {{ conversion.paymentReference }}
          </td>
        </tr>
        <tr>
          <th>
            Reference (PSP)
          </th>
          <td>
            {{ conversion.paymentPspReference }}
          </td>
        </tr>
        <tr>
          <th>
            Initial Reference
          </th>
          <td>
            {{ conversion.paymentInitialReference }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Technical</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>IP</th>
          <td>{{ conversion.ip }}</td>
        </tr>
        <tr>
          <th>User Agent</th>
          <td>{{ conversion.userAgent }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Customer</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Firstname</th>
          <td>{{ conversion.firstname }}</td>
        </tr>
        <tr>
          <th>Lastname</th>
          <td>{{ conversion.lastname }}</td>
        </tr>
        <tr>
          <th>Address</th>
          <td>{{ conversion.address }}</td>
        </tr>
        <tr>
          <th>Postal Code</th>
          <td>{{ conversion.postalCode }}</td>
        </tr>
        <tr>
          <th>City</th>
          <td>{{ conversion.city }}</td>
        </tr>
        <tr>
          <th>Language</th>
          <td>{{ conversion.language }}</td>
        </tr>
        <tr>
          <th>Country</th>
          <td>
            @if (conversion.country) {
              <img [ngSrc]="countryService.getFlag(conversion.country)"
                [alt]="conversion.country" width="24" height="24" class="me-1">
            }
          </td>
        </tr>
        <tr>
          <th>E-mail</th>
          <td>{{ conversion.email }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Tracking</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Partner</th>
          <td>{{ conversion.partner }}</td>
        </tr>
        <tr>
          <th>Promotion link</th>
          <td>{{ conversion.landingPage }}</td>
        </tr>
        <tr>
          <th>Offer</th>
          <td>{{ conversion.offer }}</td>
        </tr>
        <tr>
          <th>Sub ID</th>
          <td>{{ conversion.subid }}</td>
        </tr>
        <tr>
          <th>TC1</th>
          <td>{{ conversion.tc1 }}</td>
        </tr>
        <tr>
          <th>TC2</th>
          <td>{{ conversion.tc2 }}</td>
        </tr>
        <tr>
          <th>TC3</th>
          <td>{{ conversion.tc3 }}</td>
        </tr>
        <tr>
          <th>TC4</th>
          <td>{{ conversion.tc4 }}</td>
        </tr>
        <tr>
          <th>Click ID</th>
          <td>{{ conversion.clickid }}</td>
        </tr>
        <tr>
          <th>Google CLID</th>
          <td>{{ conversion.gclid }}</td>
        </tr>
        <tr>
          <th>Facebook CLID</th>
          <td>{{ conversion.fbclid }}</td>
        </tr>
        <tr>
          <th>Facebook PXID</th>
          <td>{{ conversion.fbpxid }}</td>
        </tr>
        <tr>
          <th>Microsoft Click ID</th>
          <td>{{ conversion.msclkid }}</td>
        </tr>
        <tr>
          <th>Microsoft Pixel ID</th>
          <td>{{ conversion.mspxid }}</td>
        </tr>
        <tr>
          <th>X Click ID</th>
          <td>{{ conversion.twclid }}</td>
        </tr>
        <tr>
          <th>X Pixel ID</th>
          <td>{{ conversion.twpxid }}</td>
        </tr>
        <tr>
          <th>Tiktok Click ID</th>
          <td>{{ conversion.ttclid }}</td>
        </tr>
        <tr>
          <th>Tiktok Pixel ID</th>
          <td>{{ conversion.ttpxid }}</td>
        </tr>
        <tr>
          <th>Source</th>
          <td>{{ conversion.source }}</td>
        </tr>
        <tr>
          <th>Referer</th>
          <td>{{ conversion.referer }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Affiliation</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Payout</th>
          <td>
            {{ (conversion.payout ? conversion.payout / 100 : '') | currency:2:$safeNavigationMigration(conversion.currency?.isoCode) }}
          </td>
        </tr>
        <tr>
          <th>Payout Reason</th>
          <td>
            {{ conversion.payoutReason }}
          </td>
        </tr>
      </tbody>
    </table>
    @if (conversion.customPayout; as customPayout) {
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Custom Payout</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ customPayout.id }}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{{ customPayout.name }}</td>
          </tr>
          <tr>
            <th>Partner</th>
            <td>{{ customPayout.partner }}</td>
          </tr>
          <tr>
            <th>Goal</th>
            <td>{{ customPayout.goal }}</td>
          </tr>
          <tr>
            <th>Goal type</th>
            <td>{{ customPayout.goalType }}</td>
          </tr>
          @if (customPayout.payoutAmount) {
            <tr>
              <th>Payout amount</th>
              <td>{{ customPayout.payoutAmount | currency:2:$safeNavigationMigration(customPayout.currency?.isoCode) }}</td>
            </tr>
          }
          @if (customPayout.payoutPercent) {
            <tr>
              <th>Payout percent</th>
              <td>{{ customPayout.payoutPercent | percent }}</td>
            </tr>
          }
          <tr>
            <th>Currency</th>
            <td>{{ customPayout.currency }}</td>
          </tr>
          @for (offer of customPayout.offers; track offer; let i = $index) {
            <tr>
              <th>Offer {{ i + 1 }}</th>
              <td>{{ offer }}</td>
            </tr>
          }
          @for (subId of customPayout.subIds; track subId; let i = $index) {
            <tr>
              <th>SubID {{ i + 1 }}</th>
              <td>{{ subId }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}
</div>
